import { Alert, AlertIcon, Box, Button, Container, Spinner, Stack } from '@chakra-ui/react';
import React, { ReactNode } from 'react';
import { useAdminAuthContext } from '../../contexts/AdminAuthProvider';
import AdminLogin from '../AdminLogin';

interface AdminGateProps {
  children: ReactNode;
}

const AdminGate = ({ children }: AdminGateProps) => {
  const { isLoading, isAuthenticated, isAdminUser, user, logout } = useAdminAuthContext();

  if (isLoading) {
    return (
      <Container centerContent maxW="container.sm" py={20}>
        <Spinner />
      </Container>
    );
  }

  if (!isAuthenticated) {
    return <AdminLogin />;
  }

  if (!isAdminUser) {
    return (
      <Container centerContent maxW="container.sm" py={20}>
        <Box borderWidth="1px" borderRadius="lg" p={8} width="100%">
          <Stack spacing={4}>
            <Alert status="error" borderRadius="md">
              <AlertIcon />
              {user?.email} no tiene permisos de administrador
            </Alert>
            <Button onClick={logout} variant="outline">
              Salir
            </Button>
          </Stack>
        </Box>
      </Container>
    );
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default AdminGate;
